import moment from 'moment';

const formatDateString = (unix) => {
  return moment.unix(unix).format('Do MMM YYYY');
};

export const generateReservationExportData = (data, start, end, module) => {
  let tempList = [];
  if (module !== 'hk') {
    tempList = data?.map((e) => {
      return {
        ...e,
        customDate: moment.unix(e.date).format('DD/MM/YYYY'),
      };
    });
  }

  let fields = [];
  let tempData = [];
  let customData = [];
  if (module === 'reservation') {
    fields = ['customDate', 'guestName', 'bookingNumber', 'noOfGuests'];
    tempData = generatePdfTable(tempList, fields);
    customData = [
      ['RESTAURANT'],
      [' '],
      ['Reservation List'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Date', 'Guest Name', 'Booking Number', 'No of Guests'],
      ...tempData,
    ];
  } else if (module === 'spa') {
    fields = ['customDate', 'spaName', 'bookingId', 'noOfGuests'];
    tempData = generatePdfTable(tempList, fields);
    customData = [
      ['SPA'],
      [' '],
      ['Appointment List'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Date', 'Spa', 'Booking Number', 'No of Guests'],
      ...tempData,
    ];
  } else if (module === 'hk') {
    let tempData2 = [];
    if (data && data?.categoryPieChartData) {
      let temp = JSON.parse(data?.categoryPieChartData);
      fields = ['name', 'value'];
      tempData = generatePdfTable(temp, fields);
      tempData2 = generatePdfTable(data?.topRequestedServices, [
        'name',
        'count',
        'averageResponseTime',
      ]);
    }
    customData = [
      ['HOUSEKEEPING'],
      [' '],
      ['Services'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Total Requests Received', data?.totalRequest],
      ['Avg Response Time (ART)', `${data?.averageResponseTime} mins`],
      [''],
      ['TOP REQUEST SERVICES'],
      [''],
      ['Total Top Requested Services', data?.totalServiceRequest],
      [''],
      ['Name', 'Count', 'ART(mins)'],
      ...tempData2,
      [''],
      ['CATEGORIES'],
      [''],
      ['Name', 'Value'],
      ...tempData,
    ];
  }

  return customData;
};

export const generateTotalReservationExportData = (data, start, end, module) => {
  let header = [];
  let body = [];

  let customData = [];

  if (module === 'reservation') {
    if (data && data?.dailyTotal?.values) {
      let tempData = data?.dailyTotal?.values;
      body = generateChartPdfExportData(tempData);
      const tempRest = data?.dailyTotal?.restaurants;
      header = ['Date', ...tempRest];
    }
    customData = [
      ['RESTAURANT'],
      [' '],
      ['Reservations'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Total Reservations', data?.total],
      [''],
      [...header],
      ...body,
    ];
  } else if (module === 'spa') {
    if (data && data?.dailyTotal?.values) {
      let tempData = data?.dailyTotal?.values;
      body = generateChartPdfExportData(tempData);
      const tempRest = data?.dailyTotal?.spas;
      header = ['Date', ...tempRest];
    }
    customData = [
      ['SPA'],
      [' '],
      ['Appointments'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Total Spa Appointments', data?.total],
      [''],
      [...header],
      ...body,
    ];
  } else if (module === 'hk') {
    if (data && data?.dailyTotal?.values) {
      let tempData = JSON.parse(data?.dailyTotal?.values);
      body = generateChartPdfExportData(tempData);
      header = ['Date', 'Requests'];
    }
    customData = [
      ['HOUSEKEEPING'],
      [' '],
      ['Requests'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Successful Requests', data?.successfulRequest],
      [''],
      ['Failed Requests', data?.failedRequest],
      [''],
      ['Total Requests', data?.totalRequest],
      [''],
      [...header],
      ...body,
    ];
  } else if (module === 'checkIn') {
    if (data && data?.checkInCheckOutGraph?.values) {
      let tempData = JSON.parse(data?.checkInCheckOutGraph?.values);
      body = generateChartPdfExportData(tempData).sort((a, b) =>
        moment(a[0], 'Do MMM YYYY').diff(moment(b[0], 'Do MMM YYYY')),
      );
      const tempRest = data?.checkInCheckOutGraph?.labels;
      header = ['Date', ...tempRest];
    }
    customData = [
      ['DIGITAL CHECK-IN'],
      [' '],
      ['Total Check-in and Check-out Activity'],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      [...header],
      ...body,
    ];
  } else if (module === 'checkInUpsell') {
    if (data && data?.upsellActivityGraph) {
      let tempData = JSON.parse(data?.upsellActivityGraph);
      body = generateChartPdfExportData(tempData).sort((a, b) =>
        moment(a[0], 'Do-MM-YYYY').diff(moment(b[0], 'Do-MM-YYYY')),
      );
      header = ['Date', 'Value'];
    }
    customData = [
      ['DIGITAL CHECK-IN UPSELL'],
      [' '],
      ['Total Upsell Activity'],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      [...header],
      ...body,
    ];
  } else if (module === 'digitalCheckIn') {
    let temp = data?.digitalCheckIn;

    customData = [
      ['ANALYTICS'],
      [''],
      ['Digital Check-in'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      [
        'Digital Check-ins (Users)',
        `${temp?.checkInAdoption?.formattedValue || 0}`,
        `${temp?.checkInAdoption?.percentage || 0} %`,
      ],
      [
        'Document uploaded (Documents)',
        `${temp?.documentsUploaded?.formattedValue || 0}`,
        `${temp?.documentsUploaded?.percentage || 0} %`,
      ],
      [
        'Payments (Total Payments)',
        `${temp?.totalPayments?.formattedValue || 0}`,
        `${temp?.totalPayments?.percentage || 0} %`,
      ],
      [
        'payments (Total Revenues)',
        `${temp?.totalPaymentsRevenue?.formattedValue || 0}`,
        `${temp?.totalPayments?.percentage || 0} %`,
      ],
      [
        'Total Key Generation(Keys)',
        `${
          (parseInt(temp?.totalKeyGeneration?.value) || 0) +
          (parseInt(temp?.totalKeyGenerationsFailed?.value) || 0)
        }`,
        `${
          (parseFloat(temp?.totalKeyGeneration?.percentage) || 0) +
          (parseFloat(temp?.totalKeyGenerationsFailed?.percentage) || 0)
        } %`,
      ],
      [
        'Successful Key Generation(Keys)',
        `${temp?.totalKeyGeneration?.value || 0}`,
        `${temp?.totalKeyGeneration?.percentage || 0} %`,
      ],
      [
        'Failures Key generation(keys)(Keys)',
        `${temp?.totalKeyGenerationsFailed?.value || 0}`,
        `${temp?.totalKeyGenerationsFailed?.percentage || 0} %`,
      ],
      [
        'Total Digital Check-ins',
        `${temp?.totalCheckIns?.formattedValue || 0}`,
        `${temp?.totalCheckIns?.percentage || 0} %`,
      ],
      [
        'Total Failed Check Ins',
        `${temp?.totalFailedCheckIns?.formattedValue || 0}`,
        `${temp?.totalFailedCheckIns?.percentage || 0} %`,
      ],
      [
        'Reattempted Check Ins',
        `${temp?.reattemptedCheckIns?.formattedValue || 0}`,
        `${temp?.reattemptedCheckIns?.percentage || 0} %`,
      ],
      [
        'Pre Check-ins',
        `${temp?.preCheckIns?.formattedValue || 0}`,
        `${temp?.preCheckIns?.percentage || 0} %`,
      ],
      [
        'Check-ins Completed',
        `${temp?.checkInCompleted?.formattedValue || 0}`,
        `${temp?.checkInCompleted?.percentage || 0} %`,
      ],
      [
        'E-Registration Received',
        `${temp?.eRegistrationsReceived?.formattedValue || 0}`,
        `${temp?.eRegistrationsReceived?.percentage || 0} %`,
      ],
      [
        'Total Revenue',
        `${temp?.totalRevenue?.formattedValue || 0}`,
        `${temp?.totalRevenue?.percentage || 0} %`,
      ],
    ];
  } else if (module === 'digitalCheckinChannel') {
    let tempData = [];
    if (data) {
      const fields = ['name', 'formattedCount', 'percentage'];
      tempData = generatePdfTable(data, fields);
    }
    let test = [];
    tempData.forEach((element) => {
      if (element[1] === '0') {
        element[1] = 'No Data';
      }
      if (element[2] === '---') {
        element[2] = 'No Data';
      }
      test.push(element);
    });
    customData = [
      ['DIGITAL CHECK-IN'],
      [' '],
      ['Channels'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['Name', 'Count', 'Percentage (%)'],
      ...test,
    ];
  } else if (module === 'digitalCheckInPreEMail') {
    let temp = data?.preArrivalEmails;

    customData = [
      ['DIGITAL CHECK-IN'],
      [' '],
      ['Pre Arrival Emails'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      [
        'Total Email Sent',
        `${temp?.totalEmailsSent?.formattedValue || 0}`,
        `${temp?.totalEmailsSent?.percentage || 0} %`,
      ],
      [
        'Total Email Delivered',
        `${temp?.totalEmailsDelivered?.formattedValue || 0}`,
        `${temp?.totalEmailsDelivered?.percentage || 0} %`,
      ],
      [
        'Check-in Initiated',
        `${temp?.checkInInitiated?.formattedValue || 0}`,
        `${temp?.checkInInitiated?.percentage || 0} %`,
      ],
      [
        'No Responses',
        `${temp?.noResponses?.formattedValue || 0}`,
        `${temp?.noResponses?.percentage || 0} %`,
      ],
    ];
  } else if (module === 'ird-order') {
    let menuHeader = [];
    let menuBody = [];
    let body = [];
    let header = [];
    if (data && data?.totalOrdersGraph?.values) {
      let tempData = JSON.parse(data?.totalOrdersGraph?.values);
      body = generateChartPdfExportData(tempData);
      const tempRest = data?.totalOrdersGraph?.labels;
      header = tempData.length ? ['Date', ...tempRest] : ['No Data'];
    }

    if (data && data?.ordersByMenuGraph?.values) {
      let tempData = JSON.parse(data?.ordersByMenuGraph?.values);
      menuBody = generateChartPdfExportData(tempData);
      const tempRest = data?.ordersByMenuGraph?.menus;
      menuHeader = menuBody.length > 0 ? ['Date', ...tempRest] : ['No Data'];
    }
    customData = [
      ['IN-ROOM DINING'],
      [' '],
      ['IRD Orders'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['ORDERS'],
      [''],
      [
        'Total Orders',
        `${data?.totalOrders?.count || 0}`,
        `${data?.totalOrders?.percentage || 0} %`,
      ],
      [
        'Total Revenue',
        `${data?.totalRevenue?.count || 0}`,
        `${data?.totalRevenue?.percentage || 0} %`,
      ],
      [
        'Avg Delivery Time',
        `${data?.avgDeliveryTime?.avgTime?.formattedValue || 0}`,
        `${data?.avgDeliveryTime?.difference || 0} mins`,
      ],
      [
        'Order Frequency per room',
        `${data?.orderPerDay?.ordersPerDay || 0}`,
        `${data?.orderPerDay?.percentage || 0} %`,
      ],
      [''],
      ['Total Orders'],
      [''],
      [...header],
      ...body,
      [''],
      ['Orders by Menu'],
      [''],
      [...menuHeader],
      ...menuBody,
    ];
  } else if (module === 'ird-items') {
    let tempData = [];
    let itemData = [];
    let upsellData = [];
    let header = ['Name', 'Count', 'Revenue'];
    if (data && data?.categoryList) {
      let temp = JSON.parse(data?.categoryList);
      let fields = ['name', 'value'];
      tempData = generatePdfTable(
        temp.filter((item) => item.value !== 0),
        fields,
      );
      itemData = generatePdfTable(data?.itemList, ['itemName', 'count', 'revenue']);
      upsellData = generatePdfTable(data?.upsellItemList, ['itemName', 'count', 'revenue']);
    }

    customData = [
      ['IN-ROOM DINING'],
      [' '],
      ['IRD Items'],
      [''],
      ['Generated Date', moment().format('DD/MM/YYYY')],
      ['From Date', moment(start).format('DD/MM/YYYY')],
      ['To Date', moment(end).format('DD/MM/YYYY')],
      [''],
      ['CATEGORIES'],
      [''],
      ['Name', 'Value'],
      ...tempData,
      [''],
      ['Top Selling Items'],
      [''],
      ['Total Count', data?.totalItemCount],
      ['Total Revenue', data?.totalItemRevenue],
      [''],
      [...header],
      ...itemData,
      [''],
      ['Top Upsell Items'],
      [''],
      ['Total Count', data?.totalUpsellCount],
      ['Total Revenue', data?.totalUpsellRevenue],
      [''],
      [...header],
      ...upsellData,
    ];
  }

  return customData;
};

export const generatePdfTable = (arr, columns, delimiter = ',') => {
  return arr.length
    ? arr.map((obj) =>
        columns.reduce(
          (acc, key) =>
            `${acc}${!acc.length ? '' : delimiter}${!obj[key] ? '---' : obj[key]}`.split(','),
          '',
        ),
      )
    : [['No data']];
};

export const generateChartPdfExportData = (data) => {
  return data.length
    ? data.map((x) => {
        const dateValue = x?.date;
        return [formatDateString(dateValue), x?.orderCount, x?.orderAmount, x?.avgOrderItemsCount];
      })
    : [['No data']];
};
